import React from 'react';
import { Radio, Header } from 'semantic-ui-react'

const FormsInputsRadioGroup = ({field, form: {touched, errors}, ...props}) => {
    const hasError = (errors[field.name] && [field.name]) ? true : false;
    console.log('', props)
    return (
        <div className="field">
            <>
                <Header sub>{props.label}</Header>
                {(props.secondaryLabel) ? <Header.Subheader>{props.secondaryLabel}</Header.Subheader>: ''}
            </>
            <Radio 
                name={field.name}
                id="radio1" 
                value="radio1" 
                checked={"radio1" === field.value}
                label='Elliot, Li' 
                onChange={field.onChange} 
                onBlur={field.onBlur}
                style={{display: 'block', padding: 5}}
            />
            <Radio 
                name={field.name}
                id="radio2" 
                value="radio2" 
                checked={"radio2" === field.value}
                label='Rachel Ying Xuan, Tan' 
                onChange={field.onChange} 
                onBlur={field.onBlur}
                style={{display: 'block', padding: 5}}
            />
            <Radio 
                name={field.name}
                id="radio3" 
                value="radio3" 
                checked={"radio3" === field.value}
                label='Jason, Li' 
                onChange={field.onChange} 
                onBlur={field.onBlur}
                style={{display: 'block', padding: 5}}
            />
            {hasError && <div>{errors[field.name]}</div>}
        </div>
    );
}

export default FormsInputsRadioGroup;